// Forgot Password Service - API calls for the self-service reset flow
import axios from 'axios';
import config from '../config';

// Create axios instance without auth interceptors (public endpoints)
const publicApi = axios.create({
  baseURL: config.api.base_url,
  timeout: 30000,
});

/**
 * Request a password reset code for an email.
 * The backend always answers with the same neutral message, whether or not
 * the account exists - never branch UI on "account found".
 * @param {string} email
 * @returns {Promise<{success: boolean, data: object, message: string}>}
 */
export const requestPasswordReset = async (email) => {
  try {
    const response = await publicApi.post('/auth/forgot-password', { email });
    return {
      success: response.data.status,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data?.data || null,
      message: error.response?.data?.message || 'Failed to request a reset code',
    };
  }
};

/**
 * Verify the emailed 6-digit reset code.
 * On success the response carries the set-password sessionToken.
 * @param {string} email
 * @param {string} code
 * @returns {Promise<{success: boolean, data: object, message: string}>}
 */
export const verifyPasswordResetCode = async (email, code) => {
  try {
    const response = await publicApi.post('/auth/forgot-password/verify', { email, code });
    return {
      success: response.data.status,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data?.data || null,
      message: error.response?.data?.message || 'Code verification failed',
    };
  }
};
